// Auto-generated by scripts/generate-eligibility-questionnaires.mjs — do not edit.
// Re-run via pnpm generate:eligibility-questionnaires (also runs before dev, build, and start).

import type { EligibilityQuestionnaireDTOType } from '@/components/questionnaire/types'
import cyGaHealthDeptQuestionnaire from '../../../eligibility-questionnaire/cy-ga-health-dept-questionnaire.json'
import cyJeffersonWiQuestionnaire from '../../../eligibility-questionnaire/cy-jefferson-wi-questionnaire.json'
import demopartnerQuestionnaire from '../../../eligibility-questionnaire/demopartner-questionnaire.json'
import gpWetTestingAltLabQuestionnaire from '../../../eligibility-questionnaire/gp-wet-testing-alt-lab-questionnaire.json'
import sprinterHealthAetnaQuestionnaire from '../../../eligibility-questionnaire/sprinter-health-aetna-questionnaire.json'
import sprinterHealthMolinaQuestionnaire from '../../../eligibility-questionnaire/sprinter-health-molina-questionnaire.json'
import sprinterQuestionnaire from '../../../eligibility-questionnaire/sprinter-questionnaire.json'
import testQuestionnaire from '../../../eligibility-questionnaire/test-questionnaire.json'

export const partnerQuestionnaireModules: Record<string, EligibilityQuestionnaireDTOType> = {
  './cy-ga-health-dept-questionnaire.json':
    cyGaHealthDeptQuestionnaire as EligibilityQuestionnaireDTOType,
  './cy-jefferson-wi-questionnaire.json':
    cyJeffersonWiQuestionnaire as EligibilityQuestionnaireDTOType,
  './demopartner-questionnaire.json': demopartnerQuestionnaire as EligibilityQuestionnaireDTOType,
  './gp-wet-testing-alt-lab-questionnaire.json':
    gpWetTestingAltLabQuestionnaire as EligibilityQuestionnaireDTOType,
  './sprinter-health-aetna-questionnaire.json':
    sprinterHealthAetnaQuestionnaire as EligibilityQuestionnaireDTOType,
  './sprinter-health-molina-questionnaire.json':
    sprinterHealthMolinaQuestionnaire as EligibilityQuestionnaireDTOType,
  './sprinter-questionnaire.json': sprinterQuestionnaire as EligibilityQuestionnaireDTOType,
  './test-questionnaire.json': testQuestionnaire as EligibilityQuestionnaireDTOType,
}
